export const PAGE_SIZE = 25;

export function paginateRows(rows, requestedPage = 1, pageSize = PAGE_SIZE) {
  const source = Array.isArray(rows) ? rows : [];
  const size = Number.isInteger(pageSize) && pageSize > 0 ? pageSize : PAGE_SIZE;
  const total = source.length;
  const totalPages = Math.max(1, Math.ceil(total / size));
  const numericPage = Number.parseInt(requestedPage, 10) || 1;
  const page = Math.min(Math.max(numericPage, 1), totalPages);
  const start = (page - 1) * size;
  return {
    items: source.slice(start, start + size),
    page,
    pageSize: size,
    total,
    totalPages,
  };
}

export function paginationTokens(page, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
  const selected = [...new Set([1, page - 1, page, page + 1, totalPages]
    .filter(value => value >= 1 && value <= totalPages))]
    .sort((a, b) => a - b);
  const tokens = [];
  selected.forEach((value, index) => {
    if (index && value - selected[index - 1] > 1) tokens.push('ellipsis');
    tokens.push(value);
  });
  return tokens;
}
